import { render } from "./GetComponent.vue?vue&type=template&id=1140078a&scoped=true"
import script from "./GetComponent.vue?vue&type=script&lang=js"
export * from "./GetComponent.vue?vue&type=script&lang=js"

import "./GetComponent.vue?vue&type=style&index=0&id=1140078a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\rh\\Documents\\GitHub\\handover-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1140078a"]])

export default __exports__